import { ConnectionState } from 'livekit-client';
/**
 * Что делать, чтобы оказаться в комнате под нужным identity.
 *
 * livekit-client при уже установленном соединении выходит из connect() немедленно
 * («already connected to room»), поэтому повторный вызов с другим identity молча
 * ничего не менял: участник навсегда оставался под предварительным случайным id,
 * и вся адресная логика (модерация, разрешение входа) промахивалась мимо него.
 */
export function planIdentityConnect({ state, currentIdentity, desiredIdentity, isJoined, }) {
    if (state !== ConnectionState.Connected) {
        return 'connect';
    }
    if (currentIdentity === desiredIdentity) {
        return 'skip';
    }
    // Смена identity — это разрыв соединения. Во время активного звонка это
    // означало бы потерю медиа, поэтому здесь identity уже не меняем.
    if (isJoined) {
        return 'skip';
    }
    return 'reconnect';
}
